import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { SocketContextProvider } from "~contexts/Socket";
import { StreamContextProvider } from "~contexts/Stream";
import { ProductsContextProvider } from "~contexts/Products";
import { RealtimeProductsContextProvider } from "~contexts/RealtimeProducts";
import { PollContextProvider } from "~contexts/Poll";
import { ToastNotificationContextProvider } from "~contexts/ToastNotification";
import { AuthProvider } from "~contexts/Auth";
import reportWebVitals from "./reportWebVitals";
import SomaLiveThemeProvider from "./styles/themes/admin";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SomaLiveThemeProvider>
        <AuthProvider>
          <ToastNotificationContextProvider>
            <StreamContextProvider>
              <SocketContextProvider>
                <ProductsContextProvider>
                  <RealtimeProductsContextProvider>
                    <PollContextProvider>
                      <App />
                    </PollContextProvider>
                  </RealtimeProductsContextProvider>
                </ProductsContextProvider>
              </SocketContextProvider>
            </StreamContextProvider>
          </ToastNotificationContextProvider>
        </AuthProvider>
      </SomaLiveThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
